export const PIM_URL = process.env.REACT_APP_PIM_URL || 'https://orders-admin-dev.frontierag.co.uk';
export const FEATURE_FLAGS_EXTERNAL_USERS =
  process.env.VITE_FEATURE_FLAGS_EXTERNAL_USERS === 'true';
